<ng-content ng-select="rt-typeahead-source" />
<ng-template [origin]="this" [width]="width" [positions]="positions" rt-connected-overlay>
  @if (suggestionEnabled) {
    <ng-container
      *ngTemplateOutlet="
        suggestionsDropdownTpl ? suggestionsDropdownTpl : defaultSuggestionsTpl;
        context: suggestionsContext
      "
    />
  }
</ng-template>

<ng-template
  #defaultSuggestionsTpl
  let-typeaheadstate="typeaheadstate"
  [ngTemplateType]="suggestionsContext"
>
  <rt-typeahead-suggestions
    [stateName]="typeaheadstate.name"
    [stateValue]="typeaheadstate.value"
    [suggestions]="typeaheadstate.suggestions"
    [highlighted]="typeaheadstate.highlighted!"
    (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()"
    (suggestionSelect)="select($event)"
  />
</ng-template>
